import { SourceType } from '@wix/a11y-rules';
import { Image } from '@wix/design-system';
import { Music, Reels } from '@wix/wix-ui-icons-common';
import React from 'react';
import { HTTP_PREFIX } from '../../../../consts';
import { resolveImageUrl } from '../../../../utils/resolve-image-url';
import { extractMediaUri } from '../../alt-image-fixer/utils/extract-media-uri';
const MEDIA_ICONS = {
  [SourceType.VIDEO]: Reels,
  [SourceType.AUDIO]: Music
};
const MediaAlternativeRuleThumbnail = _ref => {
  let {
    sourceType = SourceType.VIDEO,
    uri = ''
  } = _ref;
  const extractedUri = extractMediaUri(uri);
  const urlToShow = uri.startsWith(HTTP_PREFIX) ? uri : resolveImageUrl(extractedUri, 50, 50);
  const MediaIcon = sourceType ? MEDIA_ICONS[sourceType] : Reels;
  return /*#__PURE__*/React.createElement(React.Fragment, null, urlToShow && uri ? /*#__PURE__*/React.createElement(Image, {
    borderRadius: "3px",
    src: urlToShow
  }) : /*#__PURE__*/React.createElement(MediaIcon, null));
};
export default MediaAlternativeRuleThumbnail;
//# sourceMappingURL=media-alternative-rule-thumbnail.js.map